import { Player } from './player';
import { SentStatus } from '../enum/sent-status';
import { SafeResourceUrl } from '@angular/platform-browser';

export interface MessagePart {
    kind: 'text' | 'image' | 'video' | 'youtube';
    text?: string;
    url?: string;
    embedUrl?: SafeResourceUrl;
}

export class Message {
    id?: string;
    localId?: string;
    clientMessageId?: string;
    chatId: string;
    text: string = '';
    sender: Player;
    readonly created: number;
    createdDateString: string;
    likesCount: number;
    dislikesCount: number;
    votedByPlayers: string[];
    inappropriate: boolean;
    deleted: boolean;
    blockedSender: boolean;
    revealedBlocked: boolean;
    marker: string;
    sent: SentStatus;
    parts: MessagePart[] = [];
    messages: Message[];

    constructor() {
        this.created = Date.now();
        this.createdDateString = "";
        this.likesCount = 0;
        this.dislikesCount = 0;
        this.votedByPlayers = Array<string>();
        this.inappropriate = false;
        this.deleted = false;
        this.blockedSender = false;
        this.revealedBlocked = false;
        this.marker = "";
        this.sent = SentStatus.NOT_SENT;
        this.messages = Array<Message>();
    }

    toString(): string {
        const { created, text } = this;
        return `Message created at: ${created} - Text: ${text}`;
    }
}
